import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getWarehouse() {
    return client.get("/tunnel/api/pos/common/warehouse");
}

function getProduct(params) {
    return client.get("/tunnel/api/pos/po/product-to-po-mb", {
        params: params,
    });
}

function getBankAccount(params) {
    return client.get("/tunnel/api/public/general/bank-account", {
        params: params,
    });
}

function savePO(params) {
    return client.post("tunnel/api/pos/po/create", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function getMinimumBV() {
    return client.get("/tunnel/api/pos/po/minimum-bv", {
    });
}

function getBank(params) {
    return client.get("/tunnel/api/public/general/bank", {
        params: params,
    });
}

function getProgressivePrice() {
    return client.get("/tunnel/api/pos/po/progressive-price", {
    });
}

export default {
    getWarehouse,
    getProduct,
    getBankAccount,
    savePO,
    getMinimumBV,
    getBank,
    getProgressivePrice
};